import Navbar from './Navbar';

export default function Contact() {
    return(
        <>


        <center><h1>Contact</h1></center>

        <Navbar />
        
        
        
        </>
    )
}